import { useEffect, useState } from "react";

const REDIRECT_URL = "https://eticket2.petrosains.com.my";
const REDIRECT_DELAY_SECONDS = 7;

export default function SuccessPage({ emailConfirmed = false }) {
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_DELAY_SECONDS);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((s) => (s > 0 ? s - 1 : 0));
    }, 1000);

    const timeout = setTimeout(() => {
      window.location.href = REDIRECT_URL;
    }, REDIRECT_DELAY_SECONDS * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div
      className="flex min-h-screen min-h-[100svh] flex-col font-good text-[#263B51] relative bg-cover bg-center bg-fixed bg-no-repeat"
      style={{ backgroundImage: "url('/wall.jpg')" }}
    >
      <style>{`
        @keyframes successAppear {
          from {
            opacity: 0;
            transform: translateY(0.75rem);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .success-appear {
          animation: successAppear 1000ms
            cubic-bezier(0.22, 1, 0.36, 1) both;
        }

        @media (prefers-reduced-motion: reduce) {
          .success-appear {
            animation: none;
          }
        }
      `}</style>

      {/* Затемняющий/осветляющий слой для читаемости текста поверх картинки */}
      <div className="absolute inset-0 bg-white/50 backdrop-blur-xs z-0" aria-hidden="true" />

      <div className="relative z-10 flex flex-col flex-1">
        <header className="border-b border-[#12345A]/10 bg-white/80 backdrop-blur-md">
          <div className="mx-auto flex h-16 max-w-md items-center justify-center px-6">
            <span className="text-sm font-semibold text-[#12345A]">
              <img src="/logo.png" className="h-8" alt="Petrosains Logo" />
            </span>
          </div>
        </header>

        <main className="mx-auto flex w-full max-w-md flex-1 flex-col px-6 pb-8 pt-10">
          {/* Success icon */}
          <div className="success-appear mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#E7EFEA] text-[#397455] shadow-sm">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              className="h-8 w-8"
              aria-hidden="true"
            >
              <path
                d="m5 12 4 4L19 6"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* Confirmation message */}
          <div
            className="success-appear mt-6 text-center"
            style={{ animationDelay: "120ms" }}
          >
            <h1 className="text-3xl font-semibold leading-tight tracking-tight text-[#12345A]">
              Your Petrosains Visit is Confirmed!
            </h1>

            <p className="mt-4 text-sm leading-relaxed text-white">
              Your booking is successful. We have sent your e-tickets to your email.
              Please have them ready for scanning at the entrance.
            </p>
          </div>

          {/* Booking information */}
          <div
            className="success-appear mt-8 rounded-2xl border border-[#D8E5F4] bg-white/95 p-5 shadow-sm backdrop-blur-sm"
            style={{ animationDelay: "400ms" }}
          >
            <div className="flex items-start gap-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#EDF2F7] text-[#12345A]">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  className="h-5 w-5"
                  aria-hidden="true"
                >
                  <path
                    d="M15 5v2m0 4v2m0 4v2M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4V7a2 2 0 0 1 2-2z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>

              <div className="min-w-0 flex-1">
                <h2 className="text-base font-semibold text-[#12345A]">
                  E-Tickets Ready
                </h2>

                <div className="mt-3 flex items-center gap-3">
                  <span className="text-2xl font-semibold tracking-tight text-[#1e3a8a]">
                    Sent via Email
                  </span>

                  <span className="rounded-full bg-[#E7EFEA] px-2.5 py-1 text-[0.6875rem] font-semibold text-[#397455]">
                    Confirmed
                  </span>
                </div>

              
              </div>
            </div>
          </div>

          {/* Redirect to Petrosains e-Ticket portal */}
          <div
            className="success-appear mt-auto pt-8"
            style={{ animationDelay: "520ms" }}
          >
            <a
              href={REDIRECT_URL}
              className="flex min-h-14 w-full items-center justify-center rounded-lg bg-[#1e3a8a] px-5 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 shadow-lg"
            >
              Continue to Petrosains e-Tickets
            </a>

            <p className="mt-4 text-center text-xs leading-relaxed text-[#748091] font-medium bg-white/50 inline-block px-4 py-1 rounded-full mx-auto w-max backdrop-blur-sm">
              {secondsLeft > 0
                ? `Redirecting automatically in ${secondsLeft}s…`
                : "Redirecting…"}
            </p>
          </div>
        </main>
      </div>
    </div>
  );
}